import { RoomFilterType } from '../types'

const getRoomTypeColor = (theme: Theme, roomType: RoomFilterType) => {
  switch (roomType) {
    case RoomFilterType.MEETING_ROOM:
      return theme.colors.pastelBlue
    case RoomFilterType.OFFICE:
      return theme.colors.pastelGreen
    case RoomFilterType.RESTAURANT:
      return theme.colors.pastelOrange
    default:
      return theme.colors.mediumLightGrey
  }
}

export { getRoomTypeColor }
